import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeaderNew from './components/HeaderNew';
import HomePageNew from './components/HomePageNew';
import Footer from './components/Footer';
import Cookies from './components/Cookies';

// Import page components
import ProductsPage from './pages/ProductsPage';
import HerkulesPage from './pages/HerkulesPage';
import SpediciaPage from './pages/SpediciaPage';
import PredajnaPage from './pages/PredajnaPage';
import VysypPage from './pages/VysypPage';
import VyrobaWebPage from './pages/VyrobaWebPage';
import ERPPage from './pages/ERPPage';
import PokladnicnyDisplejPage from './pages/PokladnicnyDisplejPage';
import PizzaQueuePage from './pages/PizzaQueuePage';
import FastFoodPosPage from './pages/FastFoodPosPage';
import ZaloznaPage from './pages/ZaloznaPage';
import KasaWebPage from './pages/KasaWebPage';
import LeseniePage from './pages/LeseniePage';
import ONasPage from './pages/ONasPage';
import CennikPage from './pages/CennikPage';
import PriruckyPage from './pages/PriruckyPage';
import ServicesPage from './pages/ServicesPage';
import ReferencesPage from './pages/ReferencesPage';
import ContactPage from './pages/ContactPage';
import WebhostingPage from './pages/WebhostingPage';
import SecurityPage from './pages/SecurityPage';
import PcNetworksPage from './pages/PcNetworksPage';
import ProfilePage from './pages/ProfilePage';
import ActionsPage from './pages/ActionsPage';
import SupportPage from './pages/SupportPage';
import AIPage from './pages/AIPage';

// Import basic pages
import { 
  SpolupracePage, CennikSluziebiPage, 
  DedicatedHostingPage, DomainRegistrationPage, 
  WebmailPage, TechSalesPage, LocationPage 
} from './pages/BasicPages';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <HeaderNew />
        <Routes>
          <Route path="/" element={<HomePageNew />} />
          {/*O nás*/}
          <Route path="/o-nas" element={<ONasPage />} />
          
          {/* Products Routes */}
          <Route path="/produkty" element={<ProductsPage />} />
          <Route path="/produkty/herkules" element={<HerkulesPage />} />
          <Route path="/produkty/spedicia" element={<SpediciaPage />} />
          {/* <Route path="/produkty/predajna" element={<PredajnaPage />} /> */}
          <Route path="/produkty/vysyp" element={<VysypPage />} />
          <Route path="/produkty/vyrobaweb" element={<VyrobaWebPage />} />
          <Route path="/produkty/erp" element={<ERPPage />} />
          <Route path="/produkty/pokladnicny-displej" element={<PokladnicnyDisplejPage />} />
          <Route path="/produkty/pizzaqueue" element={<PizzaQueuePage />} />
          <Route path="/produkty/fastfood-pos" element={<FastFoodPosPage />} />
          <Route path="/produkty/zalozna" element={<ZaloznaPage />} />
          <Route path="/produkty/kasa-web" element={<KasaWebPage />} />
          <Route path="/produkty/lesenia" element={<LeseniePage />} />
          {/* <Route path="/produkty/cennik" element={<CennikPage />} /> */}
          {/* <Route path="/produkty/prirucky" element={<PriruckyPage />} /> */}
          
          {/* Services Routes */}
          <Route path="/sluzby" element={<ServicesPage />} />
          <Route path="/sluzby/spoluprace" element={<SpolupracePage />} />
          <Route path="/sluzby/cennik" element={<CennikSluziebiPage />} />
          
          {/* Other main pages */}
          <Route path="/referencie" element={<ReferencesPage />} />
          <Route path="/profil" element={<ProfilePage />} />
          <Route path="/bezpecnost" element={<SecurityPage />} />
          <Route path="/ai-riesenia" element={<AIPage />} />
          <Route path="/sprava-pc-sieti" element={<PcNetworksPage />} />
          
          {/* Webhosting Routes */}
          <Route path="/webhosting" element={<WebhostingPage />} />
          <Route path="/webhosting/dedikovany" element={<DedicatedHostingPage />} />
          <Route path="/webhosting/domeny" element={<DomainRegistrationPage />} />
          <Route path="/webhosting/webmail" element={<WebmailPage />} />
          
          {/* Other Routes */}
          <Route path="/predaj-techniky" element={<TechSalesPage />} />
          {/* <Route path="/akcie" element={<ActionsPage />} /> */}
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/kde-nas-najdete" element={<LocationPage />} />
          <Route path="/podpora" element={<SupportPage />} />
        </Routes>
        <Footer />
        <Cookies />
      </div>
    </Router>
  );
}

export default App;
